const getNumericValues = (dataItem) =>{
    if(dataItem == undefined) return [];
    return Object.values(dataItem).filter(val => typeof val === 'number');
}
  
const minOf = (dataItem, defaultMin = 0) => {
    const values = getNumericValues(dataItem);
    return values.length > 0 ? Math.min(...values) : defaultMin;
};

const maxOf = (dataItem, defaultMax = 100) => {
    const values = getNumericValues(dataItem);
    return values.length > 0 ? Math.max(...values) : defaultMax;
};


const maxOfStructured = (data) => {
  if (!Array.isArray(data) || data.length === 0) return 0;
  return Math.max(...data.map(item => item.value));
};

export { minOf, maxOf, maxOfStructured };
  
